import React from 'react'
import './topics.css'

const Topics = () => {
    return (
        <div className='tracks'>
            <p>
                THEMES TO HACK
            </p>
            <div className='container'>
                <div className='card'>
                    <div className='card_title'>
                        <h2>CBHW101: Aaoge Jab Tum Oh Saajna!</h2>
                    </div>
                    <div className='card_content'>
                        <p>Develop an automated Face Recognition Attendance System that accurately identifies and records the attendance of students in educational institutions. The system should be capable of processing real-time video or images, recognizing individual students' faces, and maintaining a secure and easily accessible attendance record for administrative purposes. The solution should prioritize accuracy, scalability, and user-friendliness, contributing to streamlined attendance management and enhancing the overall efficiency of educational institutions. Deploy the model on a Web App or Android/iOS App interface.</p>
                    </div>
                </div>
                <div className='card'>
                    <div className='card_title'>
                        <h2>CBHW102: Chehre Ke Peeche Kya Hai?</h2>
                    </div>
                    <div className='card_content'>
                        <p>Design an Emotion Recognition System that analyzes facial expressions and voice tones to create more immersive and emotionally responsive virtual reality experiences. Deploy the model on a Web App or Android/iOS App interface.
                            <br /><a className="link" target='_blank' href='http://mohammadmahoor.com/affectnet/'>Click here for Dataset Link</a> </p>
                    </div>
                </div>
                <div className='card'>
                    <div className='card_title'>
                        <h2>CBHW103: Bill Hai Ki Manta Nahi!</h2>
                    </div>
                    <div className='card_content'>
                        <p>Build a tool that predicts energy consumption patterns for households or businesses, enabling users to make informed decisions about energy usage and conservation. Deploy the model on a Web App or Android/iOS App interface.<br /><a className="link" target='_blank' href='https://archive.ics.uci.edu/dataset/235/individual+household+electric+power+consumption'>Click here for Dataset Link</a></p>
                    </div>
                </div>
                <div className='card'>
                    <div className='card_title'>
                        <h2>CBHW104: Phatela Jeb Sil Jayega!</h2>
                    </div>
                    <div className='card_content'>
                        <p>Design a Smart Shopping Cart with built-in sensors that help customers navigate the store and track their shopping list. The model must offer a quick and reliable automated mechanism for aiding customers in taking budget-constrained decisions while shopping.</p>
                    </div>
                </div>
                <div className='card'>
                    <div className='card_title'>
                        <h2>CBHW105: Thodi Jagah De De Mujhe!</h2>
                    </div>
                    <div className='card_content'>
                        <p>The proposed Occupancy Monitoring System must detect the occupancy status of public places like libraries or cafeterias. This type of system uses various sensors and technologies to determine whether a particular space is empty, moderately occupied, or crowded. Such a system can help people decide when to visit these places to avoid crowds and curtail unnecessary waiting time.</p>
                    </div>
                </div>
                <div className='card'>
                    <div className='card_title'>
                        <h2>CBHW106: Dil Ye Bechain Hai!</h2>
                    </div>
                    <div className='card_content'>
                        <p>Build a HealthPlus+ application that can calculate SpO2, Blood Pressure, Stress or any other possible body vitals using a Smartphone. The innovative application must screen and predict health risks/conditions for people to take a decision to whether go for an urgent Doctor consultation or not based on the level of risk.</p>
                    </div>
                </div>
                <div className='card'>
                    <div className='card_title'>
                        <h2>CBHW107: Yaaro Dosti Badi Hi Haseen Hai!</h2>
                    </div>
                    <div className='card_content'>
                        <p>Design a Web or App based platform "eSakha" for Virtual study groups. The platform should allow students to create and join study groups for specific subjects or courses. Users should be able to schedule study sessions, share resources, collaborate on virtual whiteboards, and hold video discussions. Consider integrating features like automatic session reminders, study progress tracking, and the ability to search and join public study groups.</p>
                    </div>
                </div>
                <div className='card'>
                    <div className='card_title'>
                        <h2>CBHW108: Gumnaam Hai Koi!</h2>
                    </div>
                    <div className='card_content'>
                        <p>Develop a Social Media application "FeedO" for School/College goers to conduct forums on grievances and share opinions with absolute anonymity, if intended by the member, while posting or commenting. A status update needs to be provided as a follow-up to depict whether the grievances are resolved or not.</p>
                    </div>
                </div>
                <div className='card'>
                    <div className='card_title'>
                        <h2>CBHW109: Jeena Isi Ka Naam Hai!</h2>
                    </div>
                    <div className='card_content'>
                        <p>Design a 2D/3D Game character element Birdie that moves and acts based on the user input from the keyboard/mouse. Birdie does its best to entertain its users with various jumps, tricks and/or one-liners.</p>
                    </div>
                </div>
                <div className='card'>
                    <div className='card_title'>
                        <h2>CBHW110: Chak De India!</h2>
                    </div>
                    <div className='card_content'>
                        <p>Develop any innovative solution irrespective of the domain viz. Software or Hardware or Hybrid that promotes openness, transparency, and inclusivity in society. The proposed system must involve sharing knowledge & resources to create a community-driven approach to innovation or help create a sustainable world for upcoming generations.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Topics;